var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operator-session-timer"},[_c('span',{staticClass:"_time",class:[_vm.timeModificatorClass]},[(_vm.showTimer)?[_vm._v(" "+_vm._s(_vm.formattedTotalTimeSpent)+" ")]:_c('loading-spinner',{attrs:{"size":"27px"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }